export default __webpack_public_path__ + "static/media/medium_rounded.be29d2ba.svg";